module.exports = __webpack_public_path__ + "static/img/2-3-3.0eb179e1.jpg";